// QRCodeGeneratiorPage.jsx

import React, { useState } from 'react';
import QRCodeGenerator from '../components/QRCodeGenerator';
import MainLayout from '../layouts/MainLayout';


function QRCodeGeneratorPage() {
    const [data, setData] = useState('');
    const [showQRCode, setShowQRCode] = useState(false); // State to manage whether to show the QR code

    const handleGenerateQRCode = () => {
        // Set the state to true to show the QR code component
        setShowQRCode(true);
    };

    return (
        <MainLayout>
        <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <h2>QR Code Generator</h2>
      </div>
        <div className='mt-8'>
        <input
                type="text"
                value={data}
                onChange={(e) => setData(e.target.value)}
                placeholder="Enter data for QR code"
            />
            <button className='mt-8' onClick={handleGenerateQRCode}>Generate QR Code</button>
            
            {/* Render the QRCodeGenerator component conditionally */}
            {showQRCode && <QRCodeGenerator data={data} />}
        </div>
        </MainLayout>
    );
}

export default QRCodeGeneratorPage;
